import {Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Params} from '@angular/router';
import {CompanyExposureDto} from '../../bonding_shared/model/dtos';
import {DetailsView} from '../../bonding_shared/components/details-view/details-view';
import {NgForm} from '@angular/forms';
import {GrowlService} from '../../bonding_shared/services/growl/growl.service';
import {AppConfigService, CompanyService, LoggedUserService, RouterService} from '../../bonding_shared/services';
import {Currency, ElementaryRight} from '../../bonding_shared/model/dictionary-ids';

@Component({
  selector: 'company-exposure-details',
  templateUrl: './company-exposure-details.component.pug',
})
export class CompanyExposureDetailsComponent extends DetailsView implements OnInit {
  @ViewChild('ngForm', {static: true}) ngForm: NgForm;
  companyId: number;
  self = this;
  public companyExposure: CompanyExposureDto;
  readonly Currency = Currency;

  constructor(
    private _route: ActivatedRoute,
    protected growlService: GrowlService,
    public router: RouterService,
    public appService: AppConfigService,
    public companyGuiService: CompanyService,
    private loggedUserService: LoggedUserService
  ) {
    super(growlService);
  }

  ngOnInit() {
    this.form = this.ngForm.form;
    this._route.params.subscribe((params) => this.initializeView(params));
    this.hideButtons(true);
    this.deleteButton.hidden = true;
    this.newVersionButton.hidden = true;
    this.handleButtons();
  }

  initializeView(params: Params) {
    const id = +params['id'];
    this.companyId = id;
    this.loadCompanyExposureDetails(id);
  }

  loadCompanyExposureDetails(companyId: number) {
    if (companyId > 0) {
      this.companyGuiService.getCompanyExposureDetails(companyId).subscribe({
        next: (data) => {
          this.companyExposure = data;
          this.inProgress = false;
          console.log('Exposure Details:', data);
        },
        error: (error) => this.handleServerError(error),
      });
    }
  }

  onCancel() {
    super.onCancel();
    this.companyExposure = undefined;
    this.handleButtons();
  }

  updateMasterLimit() {}

  runToCalculate(): void {
    // Add your calculation logic here update the exposure details
    if (this.companyId > 0) {
      this.companyGuiService.getUpdatedCompanyExposureDetails(this.companyId).subscribe({
        next: (data) => {
          this.companyExposure = data;
          this.inProgress = false;
          console.log('Recalculate Exposure Details:', data);
        },
        error: (error) => this.handleServerError(error),
      });
    }
  }

  hasRightsForRuntoCalculateButton(): boolean {
    return this.loggedUserService.hasRight(ElementaryRight.COMPANY_SUPER_USER);
  }
}
